/**
 * Copyright (c) 2016-2018 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    ahmet_000
 * Date      2018-09-21
 */
import no_spinner_axios from '../../utils/no-spinner-axios';

const DeviseAuthStore = {
    namespaced: true,
    state: {
        username: null,
        first_name: null,
        last_name: null,
        loggedIn: false,
        after_logout_url:null,
        roles_count:null,
        phone:null,
        email:null
    },
    mutations: {
        storeUsername(state,usernameIn){
            state.username = usernameIn;
        },
        storeFirstName(state,firstNameIn){
            state.first_name = firstNameIn;
        },
        storeLastName(state,lastNameIn){
            state.last_name = lastNameIn;
        },
        storeAfterLogoutUrl(state,afterLogoutUrl){
            state.after_logout_url = afterLogoutUrl;
        },
        storeRolesCount(state,roles_count){
            state.roles_count = roles_count;
        },
        storePhone(state,phone){
            state.phone = phone;
        },
        storeEmail(state,email){
            state.email = email;
        },
        logout (state) {
            state.loggedIn = false;
        },
        login(state) {
            state.loggedIn = true;
        }
    },
    actions: {
        show(context){
            return new Promise(callAxios);

            function callAxios(resolve, reject) {
                no_spinner_axios
                    .get('/current_user')
                    .then(success)
                    .catch(failure);

                function success(response) {
                    resolve(response.data);
                    context.commit('storeUsername',response.data.username);
                    context.commit('storeFirstName',response.data.first_name);
                    context.commit('storeLastName',response.data.last_name);
                    context.commit('storeAfterLogoutUrl',response.data.after_logout_url);
                    context.commit('storeRolesCount',response.data.user_organization_roles_count);
                    context.commit('storePhone',response.data.attribute_store['user_contact_phone']);
                    context.commit('storeEmail',response.data.email);
                }
                function failure(error) {
                    console.log(error);
                    reject(error);
                }
            }
        },
        update(context, item) {
            return new Promise(callAxios);

            function callAxios(resolve, reject) {
                no_spinner_axios
                    .put('/current_user', item)
                    .then(success)
                    .catch(failure);

                function success(response) {
                    resolve(response.data);
                    context.commit('storeUsername',response.data.username);
                    context.commit('storeFirstName',response.data.first_name);
                    context.commit('storeLastName',response.data.last_name);
                }

                function failure(error) {
                    console.log(error);
                    reject(error);
                }
            }
        },
        signin(context,credentials) {
            return new Promise(callAxios);

            function callAxios(resolve, reject) {
                no_spinner_axios
                    .post('/users/sign_in.json', credentials)
                    .then(success)
                    .catch(failure);

                function success(response) {
                    resolve(response.data);
                    context.commit('login');
                }
                function failure(error) {
                    console.log(error);
                    reject(error);
                }
            }
        },
        signout(context) {
            return new Promise(callAxios);

            function callAxios(resolve, reject) {
                no_spinner_axios
                    .delete('/users/sign_out.json')
                    .then(success)
                    .catch(failure);

                function success(response) {
                    resolve(response.data);
                    context.commit('logout');
                }
                function failure(error) {
                    console.log(error);
                    reject(error);
                }
            }
        }
    }
};
export default DeviseAuthStore;
